import React from 'react';
import SkinLogo from '../Shell/SkinLogo';
import {testata} from '../../moduli/leggi';
import {skinCorrente} from '../../skin';

/**
 * IL LOGO DELLA TESTATA NOVA: un simbolo e un nome, in alto a sinistra.
 * Dal computer sta sopra il menu, da solo: le sezioni stanno sopra la pagina.
 *
 * COSA DECIDE IL BACKOFFICE (modulo Testata, stile Nova): il nome scritto
 * (vuoto = il nome della skin) e il simbolo (una moneta crypto generica, un
 * blocco della catena, o nessuno). Se in Sito › Skin c'e' un'immagine del
 * logo, vince l'immagine: e' il marchio vero del cliente, e simbolo e nome
 * non le si mettono accanto.
 *
 * I SIMBOLI NON SONO IL MARCHIO DI UNA MONETA VERA (niente ₿ ne' rombo di
 * Ethereum): una moneta d'oro col cubo inciso, e il cubo da solo. L'oro e'
 * quello di Deposita, il blocco prende il colore principale della skin.
 */
export default function MarchioNova() {
  const skin = skinCorrente();
  const {marchio, icona} = testata();
  if (skin && skin.logoUrl) return <SkinLogo/>;
  const nome = marchio || (skin && skin.name) || '';
  if (!nome && icona === 'nessuna') return <SkinLogo/>;
  return (
    <span className={'nova-marchio'}>
      {icona === 'moneta' && <Moneta/>}
      {icona === 'blocco' && <Blocco/>}
      {/* Un nome lungo (il nome tecnico della skin, «SKIN.wincrypto») si stringe per stare sopra il menu. */}
      {nome && <span className={'nova-marchio-nome' + (nome.length > 11 ? ' lungo' : '')}>{nome}</span>}
    </span>
  );
}

/* Il cubo visto dall'alto: l'esagono e le tre facce. */
const ESAGONO = '16,9 22.06,12.5 22.06,19.5 16,23 9.94,19.5 9.94,12.5';

/** Una moneta d'oro col cubo della catena inciso. */
function Moneta() {
  return (
    <svg className={'nova-simbolo'} viewBox={'0 0 32 32'} aria-hidden={'true'}>
      <defs>
        <linearGradient id={'nova-moneta-oro'} x1={'0'} y1={'0'} x2={'1'} y2={'1'}>
          <stop offset={'0'} style={{stopColor: 'color-mix(in srgb, var(--n-gold) 55%, #fff)'}}/>
          <stop offset={'.55'} style={{stopColor: 'var(--n-gold)'}}/>
          <stop offset={'1'} style={{stopColor: '#c98a00'}}/>
        </linearGradient>
      </defs>
      <circle cx={'16'} cy={'16'} r={'15'} fill={'url(#nova-moneta-oro)'}/>
      <circle cx={'16'} cy={'16'} r={'12.2'} fill={'none'} stroke={'#7a5200'} strokeOpacity={'.35'} strokeWidth={'1.2'}/>
      <g fill={'none'} stroke={'#4a3200'} strokeWidth={'1.8'} strokeLinejoin={'round'} strokeLinecap={'round'}>
        <polygon points={ESAGONO}/>
        <polyline points={'9.94,12.5 16,16 22.06,12.5'}/>
        <line x1={'16'} y1={'16'} x2={'16'} y2={'23'}/>
      </g>
    </svg>
  );
}

/** Un blocco della catena, nel colore principale della skin. */
function Blocco() {
  return (
    <svg className={'nova-simbolo'} viewBox={'4 4 24 24'} aria-hidden={'true'}>
      <polygon points={'16,5 25.5,10.5 16,16 6.5,10.5'} style={{fill: 'var(--n-primary2)'}}/>
      <polygon points={'6.5,10.5 16,16 16,27 6.5,21.5'} style={{fill: 'var(--n-primary)'}}/>
      <polygon points={'25.5,10.5 25.5,21.5 16,27 16,16'} style={{fill: 'color-mix(in srgb, var(--n-primary) 60%, #000)'}}/>
    </svg>
  );
}
